import { render, staticRenderFns } from "./GHGProtocol.vue?vue&type=template&id=442c9fa3"
import script from "./GHGProtocol.vue?vue&type=script&lang=js"
export * from "./GHGProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports